import * as React from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import { queryClient } from 'lib/react-query';
import { useLogin, useLogout, useUser } from 'hooks/shared/auth.hooks';
import { usePersistentState } from 'hooks/shared/usePersistentState';
import cookies from 'utils/cookies';

const AuthContext = React.createContext(null);

const AuthProvider = ({ children }) => {
	// Auth state
	const [user, setUser, clearUser] = usePersistentState('user', null);
	const [authenticated, setAuthenticated] = React.useState(!!user);

	const navigate = useNavigate();
	const location = useLocation();
	const [params] = useSearchParams();

	if (!cookies.getRefreshToken() && params.get('access_token') && params.get('refresh_token')) {
		cookies.setAccessToken(params.get('access_token'));
		cookies.setRefreshToken(params.get('refresh_token'));
	}

	const loginMutation = useLogin();
	const LogoutMutation = useLogout();

	// Fetch authenticated user query
	// const fetchUserQuery = useUser({
	//     enabled: authenticated,
	// });

	const handleLogin = async () => {
		// data as a function parameter in case of password based login
		try {
			const data = await loginMutation.mutateAsync();
			// const { tokens, user } = data;
			// console.log("data", data);

			// Set the user data in the Auth Context
			// setUser(user);
			// setAuthenticated(true);

			// Store the user tokens in cookies if needed
			// cookies.setAccessToken(tokens.access.token);
			// cookies.setRefreshToken(tokens.refresh.token);

			// Refetch the user query to get the latest user data
			// queryClient.invalidateQueries('user');

			// navigate('/dashboard', { state: { from: location }, replace: true });
		} catch (error) {
			console.error('Login failed', error);
		}
	};

	const handleLogout = async () => {
		try {
			await LogoutMutation.mutateAsync();

			// Clear the user data from the Auth Context
			setUser(null);
			localStorage.removeItem('user');
			clearUser();
			setAuthenticated(false);

			// Clear the user token from cookies
			cookies.clearAccessToken();
			cookies.clearRefreshToken();

			// Redirect to the sign-in page
			navigate('/signin', { state: { from: location }, replace: true });
		} catch (error) {
			console.error('Logout failed', error);
		}
	};

	const value = {
		user,
		authenticated,
		setUser,
		setAuthenticated,
		onLogin: handleLogin,
		onLogout: handleLogout,
	};

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
	children: PropTypes.node,
};

const useAuth = () => {
	const context = React.useContext(AuthContext);
	if (context === undefined) {
		throw new Error('useAuth must be used within a AuthProvider');
	}
	return context;
};

export { AuthProvider, useAuth };
